import React from 'react'
import './RevenueIncomeCard.css'
import { ArrowDownRight } from 'lucide-react';

function INCSUBRevenueIncomeCard({ heading = '', amount = '', svgImg, bg = '', func = '', isFocused }) {
  return (
    <div className='INCSUBRevenueIncomeCard' style={{ cursor: heading !== 'Profit' ? 'pointer' : null, background: heading === isFocused ? "#f0ffff" : null }} onClick={() => {
      if (isFocused === heading) {
        return 0
      }
      func(heading)
    }}>
      <div className='INCSUBRevenueIncomeCard_heading_amount'>
        <div className='INCSUBRevenueIncomeCard_heading'>Total {heading}</div>
        <div className='INCSUBRevenueIncomeCard_amount' style={{ color: amount < 0 ? 'red' : null }}>₹{amount? amount:"0.00"}</div>
      </div>
      <div className='INCSUBRevenueIncomeCard_imageholder'>
        <div className='INCSUBRevenueIncomeCard_imageholder_div' style={{ backgroundColor: `${bg}` }}>
          {svgImg}
        </div>
      </div>

      {isFocused === heading ? <div className='arrow_container'><svg width="42" height="12" viewBox="0 0 42 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M41.5 0.5V1.37695C40.9765 1.38806 40.0503 1.53725 38.3623 2.01953C37.4118 2.29118 36.3293 2.8886 35.2471 3.60742C34.1569 4.33153 33.033 5.20243 31.9961 6.05078C30.9593 6.8991 29.9994 7.73252 29.2451 8.37793C28.8662 8.70218 28.5419 8.97721 28.2822 9.18555C28.0086 9.40509 27.8458 9.51804 27.7764 9.55273C27.4876 9.6971 27.1891 9.91978 26.9082 10.1094C26.6093 10.3111 26.2617 10.5274 25.7998 10.7295C24.8779 11.1328 23.4494 11.5 21 11.5C18.62 11.5 16.7123 10.6673 15.3936 9.82812C14.7346 9.40878 14.2258 8.99 13.8838 8.67773C13.7133 8.52204 13.5848 8.3931 13.5 8.30469C13.4576 8.26048 13.4253 8.22629 13.4053 8.2041C13.3953 8.19304 13.3881 8.18462 13.3838 8.17969L13.3799 8.1748L13.3486 8.1377L13.3105 8.1084L13.3076 8.10547C13.3055 8.10382 13.3019 8.10184 13.2979 8.09863C13.2898 8.09226 13.2782 8.08255 13.2627 8.07031C13.2313 8.04554 13.1848 8.00882 13.125 7.96191C13.0054 7.86814 12.8316 7.73251 12.6143 7.56445C12.1795 7.22826 11.5694 6.76221 10.8701 6.24219C9.47503 5.20481 7.70799 3.94198 6.25684 3.07129C4.75312 2.16913 3.18326 1.77896 1.99805 1.6123C1.40398 1.52878 0.901751 1.50018 0.545898 1.49316C0.530465 1.49286 0.514884 1.49339 0.5 1.49316V0.5H41.5Z" fill="rgb(240, 255, 255)" stroke="#B9B9B9" />
        <rect width="42" height="1" fill="white" />
      </svg>

      </div> : null}
    </div>
  )
}

export default INCSUBRevenueIncomeCard;
